import React, { useEffect, useState } from 'react';
import './Billprint2.css';

import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import {
  Document,
  Page,
  Text,
  View,
  PDFViewer,
  Font
} from '@react-pdf/renderer';
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import { styles } from './styles';

// Register the font using the imported variable
Font.register({
  family: 'Lato-Italic',
  src: LatoItalicFont,
});

const Billprint = () => {
  const [customerData, setCustomerData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('customerData');
    if (stored) {
      setCustomerData(JSON.parse(stored));
      setIsLoading(false);
    }
  }, []);

  const pageDataLength = Object.keys(customerData).length / 2;
  const minutes = Math.floor(pageDataLength / 60);
  const seconds = pageDataLength % 60;
  const totalPages = pageDataLength * 2;

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="billprintmain">
      <PDFViewer className="pdf">
        <Document>
          {Object.keys(customerData).map((kno, index) => (
            <PageTemplate
              key={index}
              data={customerData[kno]}
              index={index}
              kno={kno}
              min={minutes}
              sec={seconds}
              pages={totalPages}
            />
          ))}
        </Document>
      </PDFViewer>
      <ToastContainer />
    </div>
  );
};

function formatDate(inputDate) {
  const options = { day: '2-digit', month: 'short', year: 'numeric' };
  return new Date(inputDate).toLocaleDateString('en-US', options);
}

function PageTemplate({ data, index, kno, min, sec, pages }) {
  const [isGenerating, setIsGenerating] = useState(true);
  const knoData = data;

  useEffect(() => {
    const generatePageContent = async () => {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setIsGenerating(false);
    };
    generatePageContent();
  }, []);

  return (
    <Page
      size={localStorage.getItem('dur') === '10' ? 'A5' : 'A4'}
      orientation={localStorage.getItem('dur') === '10' ? 'landscape' : 'portrait'}
      style={styles.page}
    >
      {isGenerating ? (
        <View style={styles.loading}>
          <Text style={styles.headtextsmall3}>{`बिल तयार होत आहे, अंदाजे वेळ: ${min} मिनिटे व ${sec} सेकंड्स`}</Text>
          <Text style={styles.headtextsmall4}>{`एकूण बिल पाने : ${pages}`}</Text>
        </View>
      ) : (
        <View style={styles.pageContent}>
          <View style={styles.row1}>
            <Text style={styles.headtextsmall}>{`खाते: ${kno} (${knoData[0].cname})`}</Text>
            <Text style={styles.headtextsmall2}>{`${knoData[0].kendra}, ${localStorage.getItem('city')}`}</Text>
            <Text style={styles.headtextsmall}>{`कालावधी : ${formatDate(knoData[0].date1)}   ते   ${formatDate(knoData[0].date2)}`}</Text>
          </View>

          {knoData[0].bothornot === 'both' ? (
            <>
              <View style={styles.row2}>
                <Text style={styles.headtextsmall}>Buffalo</Text>
                <Text style={styles.headtextsmall}>Cow</Text>
              </View>
              <View style={styles.row2}>
                <Text style={styles.headtextsmallleft1}>Morning</Text>
                <Text style={styles.headtextsmallleft2}>Evening</Text>
                <Text style={styles.headtextsmallleft3}>Morning</Text>
                <Text style={styles.headtextsmallleft4}>Evening</Text>
              </View>
            </>
          ) : (
            <>
              <View style={styles.row2single}>
                <Text style={styles.headtextsmall}>
                  {knoData[0].bothornot === 'mh' ? 'Buffalo' : 'Cow'}
                </Text>
              </View>
              <View style={styles.row2both}>
                <Text style={styles.headtextsmallleft1big}>Morning</Text>
                <Text style={styles.headtextsmallleft2big}>Evening</Text>

              </View>
            </>
          )}

          {knoData[0].bothornot !== 'both' && (
            <View style={styles.tableContainer}>
              {/* Combined Morning + Evening + Total table */}
              <View style={styles.table}>
                {/* Header Row */}
                <View style={styles.tableRow}>
                  {[
                    'दिनांक',  // 0
                    'लिटर',    // 1
                    'फॅट',     // 2
                    'SNF',      // 3
                    'दर',       // 4
                    'रक्कम',    // 5 morning amount
                    'लिटर',    // 6
                    'फॅट',     // 7
                    'SNF',      // 8
                    'दर',       // 9
                    'रक्कम',    // 10 evening amount
                    'रक्कम 2'     // 11 total
                  ].map((header, i) => {
                    // determine style key
                    const key =
                      i === 11
                        ? 'tableHeadersmbigall'                 // final total column
                        : (i === 5 || i === 10)
                          ? 'tableHeadersmbig3'             // morning/evening amount
                          : (i === 4 || i === 9)
                            ? 'tableHeadersmbig2'           // rate columns
                            : 'tableHeadersmbig';           // default

                    const headerStyle = styles[key] || styles.tableHeadersmbig;

                    // spacing after morning/evening amount and before total
                    const spacerStyle = {};
                    if (i === 5 || i === 10) spacerStyle.marginRight = 10;
                    if (i === 11) spacerStyle.marginLeft = -2;

                    return (
                      <Text key={i} style={[headerStyle, spacerStyle]}>
                        {header}
                      </Text>
                    );
                  })}
                </View>

                {/* Data Rows */}
                {knoData.map((item, i) => (
                  <View style={styles.tableRow} key={`row-${i}`}>
                    {/* Date */}
                    <Text style={[styles.tableCellbig, { width: 38 }]}>
                      {item.date.substr(5).split('-').reverse().join('/')}
                    </Text>

                    {/* Morning columns */}
                    <Text style={styles.tableCellsmbig}>{item.litermormh}</Text>
                    <Text style={styles.tableCellsmbig}>{item.fatmormh}</Text>
                    <Text style={styles.tableCellmedbig}>{item.snfmormh}</Text>
                    <Text style={styles.tableCellmedbig}>{item.ratemormh}</Text>
                    <Text style={[styles.tableCellmed2big, { marginRight: 10 }]}>
                      {item.amtmormh}
                    </Text>

                    {/* Evening columns */}
                    <Text style={styles.tableCellsmbig}>{item.literevnmh}</Text>
                    <Text style={styles.tableCellsmbig}>{item.fatevnmh ?? '-'}</Text>
                    <Text style={styles.tableCellmedbig}>{item.snfevnmh ?? '-'}</Text>
                    <Text style={styles.tableCellmedbig}>{item.rateevnmh ?? '-'}</Text>
                    <Text style={[styles.tableCellmed2big, { marginRight: 10 }]}>
                      {item.amtevnmh}
                    </Text>

                    {/* Total column */}
                    <Text style={[styles.tableCellmed2bigall, { marginLeft: 0 }]}>
                      {parseFloat(item.tamt).toFixed(2)}
                    </Text>
                  </View>
                ))}
              </View>
            </View>
          )}


        </View>
      )}
    </Page>
  );
}

export default Billprint;
